const FULLSTORY_SENSITIVE = 'fs-hide';

export function markFullStorySensitive(className?: string) {
  return className ? `${className} ${FULLSTORY_SENSITIVE}` : FULLSTORY_SENSITIVE;
}
